import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ComponentsModule } from "../../../common-components/components.module";
import { PaetepCfBuilderContextInfoComponent } from './components/paetep-cf-builder-context-info/paetep-cf-builder-context-info.component';
import { PaetepCfBuilderSignatureComponent } from './components/paetep-cf-builder-signature/paetep-cf-builder-signature.component';
import { ErrorTailorModule } from "@ngneat/error-tailor";
import { EdlCommonComponentsModule } from "@edl-development/edl-common";


@NgModule({
    declarations: [
        PaetepCfBuilderContextInfoComponent,
        PaetepCfBuilderSignatureComponent
    ],
    imports: [
        CommonModule,
        ComponentsModule,
        FormsModule,
        ReactiveFormsModule,
        ErrorTailorModule,
        EdlCommonComponentsModule
    ],
    exports: [
        PaetepCfBuilderContextInfoComponent,
        PaetepCfBuilderSignatureComponent
    ]
})
export class PaetepCFBuilderEnhancementsModule {}
